import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Menu,
  MultiSelect,
  MultiSelectProps,
  rem,
  ScrollArea,
  Select,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedState,
  useDebouncedValue,
  useDisclosure,
  useHotkeys,
} from "@mantine/hooks";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconBuildingWarehouse,
  IconCheck,
  IconFileExport,
  IconRulerMeasure,
  IconSearch,
  IconTimeDuration15,
  IconTrademark,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { AvatarUtils } from "../../../../common/ColorByName/AvatarUtils";
import { formatDateTransfer } from "../../../../common/FormatDate/FormatDate";
import LoadingOverlayCustom from "../../../../common/LoadingOverLayCustom/LoadingOverLayCustom";
import { BASE_API_MDM } from "../../../../config";
import { _localization } from "../../../../config/location";
import { green } from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { OrderBySerialReportModel } from "../../../../model/SalesBarcode";
import { SelectListItemModel } from "../../../../model/SelectListItem";
import { getMasterOrgSelect } from "../../../../service/getSelectApi";

const SalesBarcodeV2 = () => {
  const navigate = useNavigate();
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<OrderBySerialReportModel[]>([]);
  const [dataSum, setDataSum] = useState<OrderBySerialReportModel[]>([]);
  const [dataInv, setDataInv] = useState<SelectListItemModel[]>([]);
  const [dataItem, setDataItem] = useState<any[]>([]);
  const [dataDepartment, setDataDepartment] = useState<SelectListItemModel[]>(
    [],
  );
  const [rowCount, setRowCount] = useState(0);
  const sizeGrid = { base: 12, sm: 12, md: 6, lg: 2, xl: 2 };
  const [visible, { toggle, close, open }] = useDisclosure(false);
  //search
  const userLoginHeader = JSON.parse(
    localStorage.getItem("userLoginHeader") || "{}",
  );
  const [keySearch, setKeySearch] = useDebouncedState("", 500);
  const [FromTuoiTonKho, setFromTuoiTonKho] = useDebouncedState("", 500);
  const [ToTuoiTonKho, setToTuoiTonKho] = useDebouncedState("", 500);
  const [search, setSearch] = useState<any>({
    DsIdCn: userLoginHeader?.branchId?.toString(),
    FromDate: new Date(
      new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() +
        7 * 3600 * 1000,
    )?.toISOString(),
    ToDate: new Date(new Date().getTime() + 7 * 3600 * 1000).toISOString(),
    DsIdKho: [],
    DsIdBp: [],
    DsMaHangSx: [],
    DsMaNCC: [],
  });
  const [searchItem, setSearchItem] = useState("");
  const [debouncedItemCode] = useDebouncedValue(searchItem, 1000);
  const [searchCatSegment3c, setSearchCatSegment3c] = useState("");
  const [debouncedCatSegment3c] = useDebouncedValue(searchCatSegment3c, 1000);
  const [searchCatSegment4d, setSearchCatSegment4d] = useState("");
  const [debouncedCatSegment4d] = useDebouncedValue(searchCatSegment4d, 1000);
  const [searchCatSegment5e, setSearchCatSegment5e] = useState("");
  const [debouncedCatSegment5e] = useDebouncedValue(searchCatSegment5e, 1000);
  const [searchCatSegment6f, setSearchCatSegment6f] = useState("");
  const [debouncedCatSegment6f] = useDebouncedValue(searchCatSegment6f, 1000);
  const [searchCodeItem, setSearchCodeItem] = useDebouncedState<string>(
    "",
    500,
  );
  //Chi nhánh
  const [dataBranch, setDataBranch] = useState<any[]>([]);
  //NCC
  const [dataVendor, setDataVendor] = useState<ComboboxItem[]>([]);
  //Loại
  const [dataCatSegment3c, setDataCatSegment3c] = useState<ComboboxItem[]>([]);
  const [dataCatSegment3cFirst, setDataCatSegment3cFirst] = useState<
    ComboboxItem[]
  >([]);
  //Chủng
  const [dataCatSegment4d, setDataCatSegment4d] = useState<ComboboxItem[]>([]);
  //Nhóm
  const [dataCatSegment5e, setDataCatSegment5e] = useState<ComboboxItem[]>([]);
  //Model
  const [dataCatSegment6f, setDataCatSegment6f] = useState<ComboboxItem[]>([]);
  //Brand
  const [dataBrand, setDataBrand] = useState<ComboboxItem[]>([]);

  const [isCallFirst, setIsCallFirst] = useState(false);

  const columns = React.useMemo<MRT_ColumnDef<OrderBySerialReportModel>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 100,
      },
      {
        accessorKey: "so_Ct",
        header: "Số chứng từ",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              variant="dot"
              radius="xs"
              onDoubleClick={() => handleCheckView(row)}
              style={{
                cursor: "pointer",
              }}
              size="md"
              color={renderedCellValue === null ? "red" : green.base}
            >
              {renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "ngay_Ct",
        header: "Ngày chứng từ",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ngay_Hach_Toan",
        header: "Ngày hạch toán",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ma_Vach",
        header: "Mã vạch",
      },
      {
        accessorKey: "ma_Nhvt",
        header: "Mã nhóm vật tư",
      },
      {
        accessorKey: "ma_Vt",
        header: "Mã vật tư",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge variant="light" radius="xl" color="blue" fw="bold">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "ten_Vt",
        header: "Tên vật tư",
        size: 300,
      },
      {
        accessorKey: "so_Luong",
        header: "Số lượng",
      },
      {
        accessorKey: "dvt",
        header: "Đơn vị tính",
      },
      {
        accessorKey: "gia_Von",
        header: "Giá vốn",
        Cell: ({ renderedCellValue }) => (
          <Text size="xs" fw={500}>
            {renderedCellValue
              ? `${renderedCellValue?.toLocaleString()} đ`
              : ""}
          </Text>
        ),
      },
      {
        accessorKey: "thanh_Tien",
        header: "Thành tiền",
        Cell: ({ renderedCellValue }) => (
          <Text size="xs" fw={500}>
            {renderedCellValue
              ? `${renderedCellValue?.toLocaleString()} đ`
              : ""}
          </Text>
        ),
      },
      {
        accessorKey: "tuoi_Ton_Kho",
        header: "Tuổi tồn kho",
        Cell: ({ renderedCellValue }) => (
          <Text size="xs" fw={500}>
            {renderedCellValue}
          </Text>
        ),
      },
      {
        accessorKey: "thoi_Han_Bh",
        header: "Thời hạn bảo hành",
        Cell: ({ renderedCellValue }) => (
          <Text size="xs" fw={500}>
            {renderedCellValue ? `${renderedCellValue} tháng` : ""}
          </Text>
        ),
      },
      {
        accessorKey: "ma_Cn",
        header: "Mã chi nhánh",
        size: 140,
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge variant="light" radius="xl" color="violet" fw="bold">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "ma_Kho",
        header: "Mã kho",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge variant="light" radius="xl" color="blue" fw="bold">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "ten_Kho",
        header: "Tên kho",
      },
      {
        accessorKey: "ma_Bp",
        header: "Mã bộ phận",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <>
            <Badge variant="light" radius="xl" color="blue" fw="bold">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "ma_Kh",
        header: "Mã khách hàng",
      },
      {
        accessorKey: "ten_Kh",
        header: "Tên khách hàng",
        size: 230,
        Cell: ({ renderedCellValue }) => (
          <>
            <AvatarUtils
              value={renderedCellValue?.toString()?.split("-")[0] ?? ""}
            />
          </>
        ),
      },
      {
        accessorKey: "ten_Khach_Le",
        header: "Tên khách lẻ",
        size: 250,
        Cell: ({ renderedCellValue }) => (
          <>
            <AvatarUtils
              value={renderedCellValue?.toString()?.split("-")[0] ?? ""}
            />
          </>
        ),
      },
      {
        accessorKey: "so_Dien_Thoai",
        header: "Số điện thoại",
      },
      {
        accessorKey: "ma_Linh_Vuc",
        header: "Mã lĩnh vực",
      },
      {
        accessorKey: "ten_Linh_Vuc",
        header: "Tên lĩnh vực",
      },
      {
        accessorKey: "ma_Nganh",
        header: "Mã ngành",
      },
      {
        accessorKey: "ten_Nganh",
        header: "Tên ngành",
      },
      {
        accessorKey: "ma_Loai",
        header: "Mã loại",
      },
      {
        accessorKey: "ten_Loai",
        header: "Tên loại",
      },
      {
        accessorKey: "ma_Chung",
        header: "Mã chủng",
      },
      {
        accessorKey: "ten_Chung",
        header: "Tên chủng",
      },
      {
        accessorKey: "ma_Nhom",
        header: "Mã nhóm",
      },
      {
        accessorKey: "ten_Nhom",
        header: "Tên nhóm",
      },
      {
        accessorKey: "ma_Model",
        header: "Mã model",
      },
      {
        accessorKey: "ten_Model",
        header: "Tên model",
      },
      {
        accessorKey: "pl1",
        header: "Phân loại 1",
      },
      {
        accessorKey: "ten_Pl1",
        header: "Tên phân loại 1",
      },
      {
        accessorKey: "pl2",
        header: "Phân loại 2",
      },
      {
        accessorKey: "ten_Pl2",
        header: "Tên phân loại 2",
      },
      {
        accessorKey: "pl3",
        header: "Phân loại 3",
      },
      {
        accessorKey: "ten_Pl3",
        header: "Tên phân loại 3",
      },
      {
        accessorKey: "pl4",
        header: "Phân loại 4",
      },
      {
        accessorKey: "ten_Pl4",
        header: "Tên phân loại 4",
      },
      {
        accessorKey: "pl5",
        header: "Phân loại 5",
      },
      {
        accessorKey: "ten_Pl5",
        header: "Tên phân loại 5",
      },
      {
        accessorKey: "pl6",
        header: "Phân loại 6",
      },
      {
        accessorKey: "ten_Pl6",
        header: "Tên phân loại 6",
      },
      {
        accessorKey: "ma_Hang_Sx",
        header: "Mã hãng sản xuất",
      },
      {
        accessorKey: "ten_Hang_Sx",
        header: "Tên hãng sản xuất",
      },
      {
        accessorKey: "so_Pn",
        header: "Số phiếu nhập",
      },
      {
        accessorKey: "ngay_Nhap",
        header: "Ngày nhập",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ngay_Xuat_Ban",
        header: "Ngày xuất bán",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "ma_Ncc",
        header: "Mã NCC",
      },
      {
        accessorKey: "ten_Ncc",
        header: "Tên NCC",
      },
      {
        accessorKey: "so_Hoa_Don",
        header: "Số hóa đơn",
      },
      {
        accessorKey: "ngay_Xuat_Hoa_Don",
        header: "Ngày xuất hóa đơn",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
    ],
    [],
  );

  const handleChangeSearchValue = (value: string | string[], key: string) => {
    setSearch((prevData: any) => ({
      ...prevData,
      [key]: value ? value : "",
    }));
  };

  const handleCleanKeySearch = (str: string) => {
    if (typeof str !== "string") {
      return "";
    }

    let cleaned = str.replace(/;+/g, ";").replace(/;\s*$/, "");
    return cleaned;
  };

  const filterDataByString = () => {
    const numbers = handleCleanKeySearch(debouncedCatSegment3c);

    const filteredData = dataCatSegment3c.filter((item) =>
      item.value?.includes(numbers),
    );

    return filteredData;
  };

  const sortData = () => {
    const numbers = handleCleanKeySearch(debouncedCatSegment3c)
      .split(";")
      .map((num) => num.trim());

    const matched = dataCatSegment3cFirst.filter((item) =>
      numbers.includes(item.value),
    );
    const unmatched = dataCatSegment3cFirst.filter(
      (item) => !numbers.includes(item.value),
    );

    const result = [...matched, ...unmatched];

    return result;
  };

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.so_Ct}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.so_Ct?.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            id: row.original.id_Ct,
            orderNumber: row.original.so_Ct,
            orderType: row.original.loai_Ct,
            actionType: "view",
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            id: row.original.id_Ct,
            orderNumber: row.original.so_Ct,
            orderType: row.original.loai_Ct,
            actionType: "view",
          },
        });
      }
    }
  };

  // kho
  const renderMultiSelectOptionInvCode: MultiSelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
      {checked && <IconCheck size={12} color="gray" />}
      <Text size="sm">
        {dataInv.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Flex>
  );

  //Bộ phận
  const renderMultiSelectOptionDepartment: MultiSelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
      {checked && <IconCheck size={12} color="gray" />}
      <Text size="sm">
        {dataDepartment.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Flex>
  );

  //Hãng sản xuất
  const renderMultiSelectOptionBrand: MultiSelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Flex direction={"row"} gap="sm" align="center" justify={"start"}>
      {checked && <IconCheck size={12} color="gray" />}
      <Text size="sm">
        {dataBrand.find((x: any) => x.value === option.value)?.label}
      </Text>
    </Flex>
  );

  // Memoize the menu items
  const menuItems = useMemo(() => {
    if (dataItem.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">
              {searchItem.length > 0
                ? "Không tìm thấy dữ liệu !!!"
                : "Nhập mã vật tư để tìm kiếm !!!"}
            </Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataItem.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchItem
            ?.toUpperCase()
            .includes(item.code?.toUpperCase())
            ? searchItem
                .toUpperCase()
                .split(";")
                .filter((val) => val.trim() !== item.code.toUpperCase())
                .join(";")
            : searchItem === ""
              ? item.code
              : `${searchItem};${item.code}`;

          setSearchItem(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchItem.toUpperCase().includes(item.code?.toUpperCase()) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataItem, searchItem]);

  const menuCatSegment3c = useMemo(() => {
    if (dataCatSegment3c.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment3c.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment3c.includes(item.value)
            ? searchCatSegment3c
                .split(";")
                .filter((val) => val.trim() !== item.value)
                .join(";")
            : searchCatSegment3c === ""
              ? item.value
              : `${searchCatSegment3c};${item.value}`;

          setSearchCatSegment3c(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment3c.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment3c, searchCatSegment3c]);

  const menuCatSegment4d = useMemo(() => {
    if (dataCatSegment4d.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment4d.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment4d.includes(item.value)
            ? searchCatSegment4d
                .split(";")
                .filter((val) => val.trim() !== item.value)
                .join(";")
            : searchCatSegment4d === ""
              ? item.value
              : `${searchCatSegment4d};${item.value}`;

          setSearchCatSegment4d(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment4d.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment4d, searchCatSegment4d]);

  const menuCatSegment5e = useMemo(() => {
    if (dataCatSegment5e.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment5e.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment5e.includes(item.value)
            ? searchCatSegment5e
                .split(";")
                .filter((val) => val.trim() !== item.value)
                .join(";")
            : searchCatSegment5e === ""
              ? item.value
              : `${searchCatSegment5e};${item.value}`;

          setSearchCatSegment5e(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment5e.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment5e, searchCatSegment5e]);

  const menuCatSegment6f = useMemo(() => {
    if (dataCatSegment6f.length === 0) {
      return (
        <Menu.Item>
          <Flex justify="center">
            <Text size="sm">"Không tìm thấy dữ liệu !!!"</Text>
          </Flex>
        </Menu.Item>
      );
    }

    return dataCatSegment6f.map((item, index) => (
      <Menu.Item
        key={`${item.value}-${index}`} // Better key
        onClick={() => {
          const updatedItemCode = searchCatSegment6f.includes(item.value)
            ? searchCatSegment6f
                .split(";")
                .filter((val) => val.trim() !== item.value)
                .join(";")
            : searchCatSegment6f === ""
              ? item.value
              : `${searchCatSegment6f};${item.value}`;

          setSearchCatSegment6f(updatedItemCode);
        }}
      >
        <Flex align="center" gap="xs">
          {searchCatSegment6f.includes(item.value) && (
            <IconCheck size={14} color="#808080" />
          )}
          <Text size="sm" truncate="end">
            {item.label}
          </Text>
        </Flex>
      </Menu.Item>
    ));
  }, [dataCatSegment6f, searchCatSegment6f]);

  const getDataBranch = async () => {
    const res = await getMasterOrgSelect();

    if (res) {
      setDataBranch(
        res
          ?.filter((item) => item.text !== null || item.value !== null)
          ?.map((item) => ({
            label: `${item.att1} - ${item.text}`,
            value: item.value?.toString(),
          })),
      );
      handleChangeSearchValue(userLoginHeader?.branchId?.toString(), "DsIdCn");
    }
  };

  const fetchData = async () => {
    const fromDate = new Date(search.FromDate);
    const toDate = new Date(search.ToDate);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 3);

    if (toDate > maxAllowedDate) {
      NotificationExtension.Fails("Chỉ được phép lọc dữ liệu trong 3 tháng !");
    } else if (
      searchCodeItem.length === 0 &&
      dataItem.length === 0 &&
      searchCatSegment3c.length === 0 &&
      searchCatSegment4d.length === 0 &&
      searchCatSegment5e.length === 0 &&
      searchCatSegment6f.length === 0 &&
      search?.DsMaNCC.length === 0
    ) {
      NotificationExtension.Fails(
        "Vui lòng nhập mã tìm kiếm 1 trong các tham số: mã vật tư, thuộc tính sản phẩm, mã loại, mã chủng, mã nhóm, mã model, NCC hoặc các mã tìm kiếm không hợp lệ !",
      );
    } else {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);

      let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
        pagination.pageSize
      }`;

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch}`;
      }

      if (search.DsIdCn.length > 0) {
        url += `&DsIdCn=${search.DsIdCn}`;
      }

      if (search.FromDate.length > 0) {
        url += `&FromDate=${search.FromDate}`;
      }

      if (search.ToDate.length > 0) {
        url += `&ToDate=${search.ToDate}`;
      }

      if (searchCodeItem.length > 0) {
        url += `&ItemCode=${searchCodeItem}`;
      }

      if (searchItem.length > 0) {
        const searchData = dataItem?.map(
          (item) => `&DsIdVt=${item?.value?.toUpperCase().trim()}`,
        );
        url += searchData.join("");
      }

      if (searchCatSegment3c.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment3c)
          ?.split(";")
          ?.map((item: any) => `&DsMaLoai=${item?.trim()}`);
        url += searchData.join("");
      }

      if (searchCatSegment4d.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment4d)
          ?.split(";")
          ?.map((item: any) => `&DsMaChung=${item?.trim()}`);
        url += searchData.join("");
      }

      if (searchCatSegment5e.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment5e)
          ?.split(";")
          ?.map((item: any) => `&DsMaNhom=${item?.trim()}`);
        url += searchData.join("");
      }

      if (searchCatSegment6f.length > 0) {
        const searchData = handleCleanKeySearch(searchCatSegment6f)
          ?.split(";")
          ?.map((item: any) => `&DsMaModel=${item?.trim()}`);
        url += searchData.join("");
      }

      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => {
            url += `&${key}=${encodeURIComponent(item)}`;
          });
        }
      });

      if (FromTuoiTonKho && FromTuoiTonKho?.length > 0) {
        url += `&FromTuoiTonKho=${FromTuoiTonKho}`;
      }

      if (ToTuoiTonKho && ToTuoiTonKho?.length > 0) {
        url += `&ToTuoiTonKho=${ToTuoiTonKho}`;
      }

      try {
        const response = await repositoryMdm.get(
          `/api/v1/VSalesCostBySerial/get-list${url}`,
        );
        if (response && response.success) {
          let result = response.data;
          const dataSumAPI = result?.filter((item: any) => !item.id_Ct);
          setData(result?.filter((item: any) => item.id_Ct));
          setRowCount(response.totalCount);
          setDataSum(dataSumAPI);
          setIsCallFirst(true);
          table.resetRowSelection();
        }
      } catch (error) {
        setData([]);
        setIsError(true);
        console.error(error);
        return;
      } finally {
        setIsLoading(false);
        setIsRefetching(false);
      }
    }
  };

  const handleExportData = async () => {
    const fromDate = new Date(search.FromDate);
    const toDate = new Date(search.ToDate);

    const maxAllowedDate = new Date(fromDate);
    maxAllowedDate.setMonth(fromDate.getMonth() + 3);

    if (toDate > maxAllowedDate) {
      NotificationExtension.Fails("Chỉ được phép lọc dữ liệu trong 3 tháng !");
    } else if (
      searchCodeItem.length === 0 &&
      dataItem.length === 0 &&
      searchCatSegment3c.length === 0 &&
      searchCatSegment4d.length === 0 &&
      searchCatSegment5e.length === 0 &&
      searchCatSegment6f.length === 0 &&
      search?.DsMaNCC.length === 0
    ) {
      NotificationExtension.Fails(
        "Vui lòng nhập mã tìm kiếm 1 trong các tham số: mã vật tư, thuộc tính sản phẩm, mã loại, mã chủng, mã nhóm, mã model, NCC hoặc các mã tìm kiếm không hợp lệ !",
      );
    } else {
      open(); // Hiển thị loading
      try {
        let url = `/api/v1/VSalesCostBySerial/export-bao-cao-chi-phi-ban-hang-theo-serial?Skip=${
          pagination?.pageIndex * pagination?.pageSize
        }&Take=${pagination.pageSize}`;

        if (keySearch.length > 0) {
          url += `&KeySearch=${keySearch}`;
        }

        if (search.DsIdCn.length > 0) {
          url += `&DsIdCn=${search.DsIdCn}`;
        }

        if (search.FromDate.length > 0) {
          url += `&FromDate=${search.FromDate}`;
        }

        if (search.ToDate.length > 0) {
          url += `&ToDate=${search.ToDate}`;
        }

        if (searchCodeItem.length > 0) {
          url += `&ItemCode=${searchCodeItem}`;
        }

        if (searchItem.length > 0) {
          const searchData = dataItem?.map(
            (item) => `&DsIdVt=${item?.value?.trim()}`,
          );
          url += searchData.join("");
        }

        if (searchCatSegment3c.length > 0) {
          const searchData = handleCleanKeySearch(searchCatSegment3c)
            ?.split(";")
            ?.map((item: any) => `&DsMaLoai=${item?.trim()}`);
          url += searchData.join("");
        }

        if (searchCatSegment4d.length > 0) {
          const searchData = handleCleanKeySearch(searchCatSegment4d)
            ?.split(";")
            ?.map((item: any) => `&DsMaChung=${item?.trim()}`);
          url += searchData.join("");
        }

        if (searchCatSegment5e.length > 0) {
          const searchData = handleCleanKeySearch(searchCatSegment5e)
            ?.split(";")
            ?.map((item: any) => `&DsMaNhom=${item?.trim()}`);
          url += searchData.join("");
        }

        if (searchCatSegment6f.length > 0) {
          const searchData = handleCleanKeySearch(searchCatSegment6f)
            ?.split(";")
            ?.map((item: any) => `&DsMaModel=${item?.trim()}`);
          url += searchData.join("");
        }

        Object.entries(search).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => {
              url += `&${key}=${encodeURIComponent(item)}`;
            });
          }
        });

        if (FromTuoiTonKho && FromTuoiTonKho?.length > 0) {
          url += `&FromTuoiTonKho=${FromTuoiTonKho}`;
        }

        if (ToTuoiTonKho && ToTuoiTonKho?.length > 0) {
          url += `&ToTuoiTonKho=${ToTuoiTonKho}`;
        }

        const _url = BASE_API_MDM + url;
        const token = localStorage.getItem("token");

        const response = await fetch(_url, {
          method: "GET",
          headers: {
            "Content-Type": "application/vnd.ms-excel",
            Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to download file");
        }
        const blob = await response.blob();
        const urlss = window.URL.createObjectURL(blob);
        const _name = new Date().toISOString().slice(0, 10);
        let filename = "bao_cao_ban_hang_theo_ma_vach" + _name + ".xlsx";
        const link = document.createElement("a");
        link.href = urlss;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error: any) {
        console.error("Error:", error);
        // Hiển thị thông báo lỗi
        NotificationExtension.Fails(
          error.message || "Đã xảy ra lỗi không xác định!",
        );
      } finally {
        close(); // Đóng loading
      }
    }
  };

  // const handleExportDataSll = async () => {
  //   open(); // Hiển thị loading
  //   try {
  //     let url = `/api/v1/VSalesCostBySerial/export-bao-cao-chi-phi-ban-hang-theo-serial-sll`;

  //     const _url = BASE_API_MDM + url;
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(_url, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/vnd.ms-excel",
  //         Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //       },
  //       body: JSON.stringify({
  //         KeySearch: keySearch,
  //         DsIdCn: search.DsIdCn,
  //         FromDate: search.FromDate,
  //         ToDate: search.ToDate,
  //         ItemCode: searchCodeItem,
  //         DsIdVt: dataItem?.map((i) => i?.value?.trim()),
  //         DsIdKho: search.DsIdKho,
  //         DsIdBp: search.DsIdBp,
  //         DsMaLoai: handleCleanKeySearch(searchCatSegment3c)
  //           ?.split(";")
  //           ?.filter((i) => i && String(i).length > 0)
  //           ?.map((item: any) => item?.trim()),
  //         DsMaChung: handleCleanKeySearch(searchCatSegment4d)
  //           ?.split(";")
  //           ?.filter((i) => i && String(i).length > 0)
  //           ?.map((item: any) => item?.trim()),
  //         DsMaNhom: handleCleanKeySearch(searchCatSegment5e)
  //           ?.split(";")
  //           ?.filter((i) => i && String(i).length > 0)
  //           ?.map((item: any) => item?.trim()),
  //         DsMaModel: handleCleanKeySearch(searchCatSegment6f)
  //           ?.split(";")
  //           ?.filter((i) => i && String(i).length > 0)
  //           ?.map((item: any) => item?.trim()),
  //         DsMaHangSx: search.DsMaHangSx,
  //         DsMaNCC: search.DsMaNCC,
  //         FromTuoiTonKho: FromTuoiTonKho,
  //         ToTuoiTonKho: ToTuoiTonKho,
  //       }),
  //     });

  //     if (!response.ok) {
  //       throw new Error("Failed to download file");
  //     }
  //     const blob = await response.blob();
  //     const urlss = window.URL.createObjectURL(blob);
  //     const _name = new Date().toISOString().slice(0, 10);
  //     let filename = "bao_cao_ban_hang_theo_ma_vach" + _name + ".xlsx";
  //     const link = document.createElement("a");
  //     link.href = urlss;
  //     link.download = filename;
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error: any) {
  //     console.error("Error:", error);
  //     // Hiển thị thông báo lỗi
  //     NotificationExtension.Fails(
  //       error.message || "Đã xảy ra lỗi không xác định!",
  //     );
  //   } finally {
  //     close(); // Đóng loading
  //   }
  // };

  const handleExportDataSll = async () => {
    open(); // Hiển thị loading
    try {
      const res = await repositoryMdm.post<MessageResponse<any>>(
        "/api/v1/VSalesCostBySerial/export-bao-cao-chi-phi-ban-hang-theo-serial-sll",
        {
          KeySearch: keySearch,
          DsIdCn: [search.DsIdCn],
          FromDate: search.FromDate,
          ToDate: search.ToDate,
          ItemCode: searchCodeItem,
          DsIdVt: dataItem?.map((i) => i?.value?.trim()),
          DsIdKho: search.DsIdKho,
          DsIdBp: search.DsIdBp,
          DsMaLoai: handleCleanKeySearch(searchCatSegment3c)
            ?.split(";")
            ?.filter((i) => i && String(i).length > 0)
            ?.map((item: any) => item?.trim()),
          DsMaChung: handleCleanKeySearch(searchCatSegment4d)
            ?.split(";")
            ?.filter((i) => i && String(i).length > 0)
            ?.map((item: any) => item?.trim()),
          DsMaNhom: handleCleanKeySearch(searchCatSegment5e)
            ?.split(";")
            ?.filter((i) => i && String(i).length > 0)
            ?.map((item: any) => item?.trim()),
          DsMaModel: handleCleanKeySearch(searchCatSegment6f)
            ?.split(";")
            ?.filter((i) => i && String(i).length > 0)
            ?.map((item: any) => item?.trim()),
          DsMaHangSx: search.DsMaHangSx,
          DsMaNCC: search.DsMaNCC,
          FromTuoiTonKho: FromTuoiTonKho,
          ToTuoiTonKho: ToTuoiTonKho,
        },
      );

      if (res && res.success) {
        NotificationExtension.Success(
          "Yêu cầu export báo cáo chi phí bán hàng theo serial đã được gửi thành công. File sẽ được gửi qua thông báo sau khi xử lý xong.",
        );
      }
    } catch (error: any) {
      console.error("Error:", error);
      // Hiển thị thông báo lỗi
      NotificationExtension.Fails(
        error.message || "Đã xảy ra lỗi không xác định!",
      );
    } finally {
      close(); // Đóng loading
    }
  };

  //Call kho
  const getDataInv = async () => {
    const response = await repositoryPos.get(
      `/api/v1/TblDmInventory/get-select-by-branch?branchId=${search.DsIdCn}`,
    );
    if (response && response.success) {
      const result = response.data
        ?.filter(
          (item: any) =>
            item.inventoryCode !== null ||
            item.inventoryId !== null ||
            item.inventoryName !== null,
        )
        ?.map((item: any) => ({
          label: `${item.inventoryCode} - ${item.inventoryName}`,
          value: item.inventoryId?.toString(),
        }));
      setDataInv(result);
    } else {
      setDataInv([]);
    }
  };

  //Bộ phận
  const getDataDepartment = async () => {
    const response = await repositoryPos.get(
      `/api/v1/TblDepartment/get-all?branchId=${search.DsIdCn}`,
    );
    if (response && response.success) {
      const result = response.data
        .filter(
          (item: any) =>
            item.deparmentCode !== null ||
            item.name !== null ||
            item.deparmentId !== null,
        )
        .map((item: any) => ({
          label: item.deparmentCode + " - " + item.name,
          value: item.departmentId?.toString(),
        }));
      setDataDepartment(result);
    }
  };

  //Mã vật tư
  const getDataItem = async () => {
    try {
      let url = "";

      if (
        handleCleanKeySearch(searchItem ?? "").length > 1 &&
        handleCleanKeySearch(searchItem ?? "")
          .trim()
          .includes(";")
      ) {
        const cleanKeySearch = handleCleanKeySearch(searchItem ?? "")
          ?.toUpperCase()
          ?.trim();

        url += `${cleanKeySearch
          ?.split(";")
          ?.map((item) => `&ListItemCode=${item.trim().replace(" ", "")}`)
          .join("")}`;
      } else if (
        handleCleanKeySearch(searchItem ?? "")?.includes(";") === false &&
        (searchItem ?? "")?.length > 0
      ) {
        url += `&ListItemCode=${searchItem?.toUpperCase()}`;
      }

      const response = await repositoryPos.get(
        `api/v1/TblItem/get-list?Skip=0&Take=100` + url,
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((item: any) => item.itemCode && item.itemName)
          .map((item: any) => ({
            label: item.itemCode + " - " + item.itemName,
            value: item.itemId?.toString(),
            code: item.itemCode,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItem(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };

  //Hãng sản xuất
  const getDataBrand = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmBrand/get-all",
    );

    if (res && res?.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.text !== null && item.att1 !== null)
        ?.map((item: any) => ({
          label: `${item.att1} - ${item.text}`,
          value: item.att1?.toString(),
        }));
      setDataBrand(dataAPI);
    }
  };

  //Call API NCC
  const fetchDataVendorSelect = async () => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      "/api/v1/TblVendor/get-all",
    );

    if (res && res.success) {
      const dataAPI = res.data;
      setDataVendor(
        dataAPI
          ?.filter(
            (item: any) => item.vendorCode != null && item.vendorName != null,
          )
          ?.map((item: any) => ({
            value: item.vendorCode?.toString(),
            label: `${item.vendorCode} - ${item.vendorName}`,
          })),
      );
    }
  };

  //Call API Loại
  const fetchCatSegment3c = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblCatSegment3c/get-all",
    );

    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment3c(dataAPI);
      setDataCatSegment3cFirst(dataAPI);
    }
  };

  //Call API Chủng
  const fetchCatSegment4d = async () => {
    let url = "/api/v1/TblCatSegment4d/get-list?Skip=0&Take=30";

    if (searchCatSegment3c.length > 0) {
      const searchML = handleCleanKeySearch(searchCatSegment3c).split(";");

      searchML.forEach((item) => {
        url += `&listCodeSegmentString3=${encodeURIComponent(item)}`;
      });
    }

    if (
      typeof searchCatSegment4d === "string" &&
      searchCatSegment4d?.trim()?.length > 0 &&
      !searchCatSegment4d.includes(";")
    ) {
      url += `&KeySearch=${searchCatSegment4d}`;
    } else if (
      typeof searchCatSegment4d === "string" &&
      searchCatSegment4d?.trim()?.length > 0 &&
      searchCatSegment4d.includes(";")
    ) {
      url += `&CodeString=${handleCleanKeySearch(searchCatSegment4d)
        ?.replace(/;/g, ",")
        .replace(/\s/g, "")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment4d(dataAPI);
    }
  };

  //Call API Nhóm
  const fetchCatSegment5e = async () => {
    let url = "/api/v1/TblCatSegment5e/get-list?Skip=0&Take=30";

    if (searchCatSegment4d.length > 0) {
      url += `&ListCodeString4=${handleCleanKeySearch(searchCatSegment4d)}`;
    }

    if (
      typeof searchCatSegment5e === "string" &&
      searchCatSegment5e?.trim()?.length > 0 &&
      !searchCatSegment5e.includes(";")
    ) {
      url += `&KeySearch=${searchCatSegment5e}`;
    } else if (
      typeof searchCatSegment5e === "string" &&
      searchCatSegment5e?.trim()?.length > 0 &&
      searchCatSegment5e.includes(";")
    ) {
      url += `&CodeString=${handleCleanKeySearch(searchCatSegment5e)
        ?.replace(/;/g, ",")
        .replace(/\s/g, "")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment5e(dataAPI);
    }
  };

  //Call API Model
  const fetchCatSegment6f = async () => {
    let url = "/api/v1/TblCatSegment6f/get-list?Skip=0&Take=30";

    if (searchCatSegment5e.length > 0) {
      const searchMN = handleCleanKeySearch(searchCatSegment5e).split(";");

      searchMN.forEach((item) => {
        url += `&listCodeSegmentString5=${encodeURIComponent(item)}`;
      });
    }

    if (
      typeof searchCatSegment6f === "string" &&
      searchCatSegment6f?.trim()?.length > 0 &&
      !searchCatSegment6f.includes(";")
    ) {
      url += `&KeySearch=${searchCatSegment6f}`;
    } else if (
      typeof searchCatSegment6f === "string" &&
      searchCatSegment6f?.trim()?.length > 0 &&
      searchCatSegment6f.includes(";")
    ) {
      url += `&CodeString=${handleCleanKeySearch(searchCatSegment6f)
        ?.replace(/;/g, ",")
        .replace(/\s/g, "")}`;
    }

    const res = await repositoryPos.get<MessageResponse<any>>(url);

    if (res && res.success) {
      const dataAPI = res?.data
        ?.filter((item: any) => item.codeString !== null)
        ?.map((item: any) => ({
          label: `${item.codeString} - ${item.name}`,
          value: item.codeString?.toString(),
        }));
      setDataCatSegment6f(dataAPI);
    }
  };

  useEffect(() => {
    if (isCallFirst) {
      fetchData();
    }
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    if (search.DsIdCn && search.DsIdCn.length > 0) {
      getDataInv();
      getDataDepartment();
    } else {
      setDataInv([]);
      setDataDepartment([]);
      handleChangeSearchValue([], "DsIdKho");
      handleChangeSearchValue([], "DsIdBp");
    }
  }, [search.DsIdCn]);

  useEffect(() => {
    const runAsyncFunctions = async () => {
      await Promise.all([getDataBranch(), fetchCatSegment3c()]);
    };
    const nextuse = async () => {
      await runAsyncFunctions();
    };
    nextuse();
  }, []);

  useEffect(() => {
    if (debouncedItemCode.length > 2) {
      getDataItem();
    } else {
      setDataItem([]);
    }
  }, [debouncedItemCode]);

  useEffect(() => {
    if (debouncedCatSegment3c.length === 0) {
      setSearchCatSegment4d("");
      setSearchCatSegment5e("");
      setSearchCatSegment6f("");
    }

    if (!searchCatSegment3c?.includes(";") && searchCatSegment3c.length > 0) {
      setDataCatSegment3c(filterDataByString());
    } else if (searchCatSegment3c?.includes(";")) {
      setDataCatSegment3c(sortData());
    } else if (searchCatSegment3c.length === 0) {
      setDataCatSegment3c(dataCatSegment3cFirst);
    }

    fetchCatSegment4d();
  }, [debouncedCatSegment3c]);

  useEffect(() => {
    if (debouncedCatSegment4d.length === 0) {
      setSearchCatSegment5e("");
      setSearchCatSegment6f("");
    }

    fetchCatSegment4d();
    fetchCatSegment5e();
  }, [debouncedCatSegment4d]);

  useEffect(() => {
    if (debouncedCatSegment5e.length > 0) {
      setSearchCatSegment6f("");
    }

    fetchCatSegment6f();
    fetchCatSegment5e();
  }, [debouncedCatSegment5e]);

  useEffect(() => {
    fetchCatSegment6f();
  }, [debouncedCatSegment6f]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (175 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableBottomToolbar: true,
    // manualPagination: true,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "soCt"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.so_Ct ?? undefined,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
    renderBottomToolbarCustomActions: ({ table }) => (
      <>
        <Flex justify={"start"} align={"center"}>
          <Flex align={"center"} gap={"md"}>
            <Text c={"red"} fw={1000}>
              Tổng:
            </Text>
            <Text c={"red"} fw={1000}>
              Số lượng:{" "}
              {dataSum && dataSum.length > 0 ? Number(dataSum[0]?.so_Luong) : 0}
            </Text>
            <Text c={"red"} fw={1000}>
              Giá vốn:{" "}
              {dataSum && dataSum.length > 0
                ? `${Number(dataSum[0]?.gia_Von)?.toLocaleString()} đ`
                : "0 đ"}
            </Text>
            <Text c={"red"} fw={1000}>
              Thành tiền:{" "}
              {dataSum && dataSum.length > 0
                ? `${Number(dataSum[0]?.thanh_Tien)?.toLocaleString()} đ`
                : "0 đ"}
            </Text>
          </Flex>
        </Flex>
      </>
    ),
  });

  useHotkeys([
    [
      "enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <Box pos={"relative"}>
      <LoadingOverlayCustom visible={visible} />
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px 10px",
          overflowX: "hidden",
        }}
        ref={headerRef}
      >
        <Group justify="space-between" mb={5}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"sm"} direction={"row"} align={"center"}>
            {/* Export Excel BE */}
            <Button
              leftSection={
                <IconFileExport style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => {
                handleExportData();
              }}
            >
              Export Excel
            </Button>
            <Button
              leftSection={
                <IconFileExport style={{ width: rem(14), height: rem(14) }} />
              }
              onClick={() => {
                handleExportDataSll();
              }}
            >
              Export Excel SLL
            </Button>
          </Flex>
        </Group>
        <Grid>
          <Grid.Col span={sizeGrid}>
            <TextInput
              placeholder="Nhập từ khóa"
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              searchable
              clearable
              placeholder="Chọn chi nhánh"
              size="sm"
              leftSection={<IconBrandBootstrap color="#15aabf" />}
              data={dataBranch}
              value={search.DsIdCn}
              onChange={(e) => handleChangeSearchValue(e ? e : "", "DsIdCn")}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Nhập mã kho"
              searchable
              clearable
              data={dataInv}
              value={search.DsIdKho}
              renderOption={renderMultiSelectOptionInvCode}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value, "DsIdKho");
              }}
              nothingFoundMessage={
                search.DsIdCn && search.DsIdCn?.length > 0
                  ? "Không tìm thấy dữ liệu !"
                  : "Vui lòng chọn chi nhánh !"
              }
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Nhập mã bộ phận"
              searchable
              clearable
              data={dataDepartment}
              value={search.DsIdBp}
              renderOption={renderMultiSelectOptionDepartment}
              leftSection={<IconBuildingWarehouse size={20} color="#15aabf" />}
              onChange={(value) => {
                handleChangeSearchValue(value, "DsIdBp");
              }}
              nothingFoundMessage={
                search.DsIdCn && search.DsIdCn?.length > 0
                  ? "Không tìm thấy dữ liệu !"
                  : "Vui lòng chọn chi nhánh !"
              }
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              placeholder="Nhập thuộc tính sản phẩm"
              leftSection={<IconBarcode size={20} color="#15aabf" />}
              defaultValue={searchCodeItem}
              onChange={(e) => setSearchCodeItem(e.currentTarget.value)}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã vật tư"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchItem("")}
                        style={{
                          display: searchItem.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchItem}
                    onChange={(e) => {
                      setSearchItem(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataItem.length <= 1
                        ? 32
                        : dataItem.length === 2
                          ? 64
                          : dataItem.length === 3
                            ? 96
                            : dataItem.length === 4
                              ? 128
                              : dataItem.length === 5
                                ? 160
                                : dataItem.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuItems}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              value={search.FromDate ? new Date(search.FromDate) : null}
              onChange={(e) => {
                handleChangeSearchValue(
                  e
                    ? new Date(
                        new Date(e ?? "").getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "FromDate",
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              value={search.ToDate ? new Date(search.ToDate) : null}
              onChange={(e) => {
                handleChangeSearchValue(
                  e
                    ? new Date(
                        new Date(e ?? "").getTime() + 7 * 3600 * 1000,
                      )?.toISOString()
                    : "",
                  "ToDate",
                );
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã loại"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => {
                          setSearchCatSegment3c("");
                          setDataCatSegment3c(dataCatSegment3cFirst);
                        }}
                        style={{
                          display:
                            searchCatSegment3c.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment3c}
                    onChange={(e) => {
                      setSearchCatSegment3c(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment3c.length <= 1
                        ? 32
                        : dataCatSegment3c.length === 2
                          ? 64
                          : dataCatSegment3c.length === 3
                            ? 96
                            : dataCatSegment3c.length === 4
                              ? 128
                              : dataCatSegment3c.length === 5
                                ? 160
                                : dataCatSegment3c.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment3c}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã chủng"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchCatSegment4d("")}
                        style={{
                          display:
                            searchCatSegment4d.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment4d}
                    onClick={() => {
                      if (dataCatSegment4d.length === 0) {
                        fetchCatSegment4d();
                      }
                    }}
                    onChange={(e) => {
                      setSearchCatSegment4d(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment4d.length <= 1
                        ? 32
                        : dataCatSegment4d.length === 2
                          ? 64
                          : dataCatSegment4d.length === 3
                            ? 96
                            : dataCatSegment4d.length === 4
                              ? 128
                              : dataCatSegment4d.length === 5
                                ? 160
                                : dataCatSegment4d.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment4d}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã nhóm"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchCatSegment5e("")}
                        style={{
                          display:
                            searchCatSegment5e.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment5e}
                    onClick={() => {
                      if (dataCatSegment5e.length === 0) {
                        fetchCatSegment5e();
                      }
                    }}
                    onChange={(e) => {
                      setSearchCatSegment5e(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment5e.length <= 1
                        ? 32
                        : dataCatSegment5e.length === 2
                          ? 64
                          : dataCatSegment5e.length === 3
                            ? 96
                            : dataCatSegment5e.length === 4
                              ? 128
                              : dataCatSegment5e.length === 5
                                ? 160
                                : dataCatSegment5e.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment5e}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Box w={"100%"} style={{ position: "relative" }}>
              <Menu
                width="target"
                position="bottom"
                offset={5}
                keepMounted
                closeOnItemClick={false}
              >
                <Menu.Target>
                  <TextInput
                    placeholder="Nhập mã model"
                    leftSection={<IconBarcode size={20} color="#15aabf" />}
                    rightSectionPointerEvents="all"
                    rightSection={
                      <IconX
                        size={20}
                        color="#15aabf"
                        onClick={() => setSearchCatSegment6f("")}
                        style={{
                          display:
                            searchCatSegment6f.length > 0 ? undefined : "none",
                          cursor: "pointer",
                        }}
                      />
                    }
                    value={searchCatSegment6f}
                    onClick={() => {
                      if (dataCatSegment6f.length === 0) {
                        fetchCatSegment6f();
                      }
                    }}
                    onChange={(e) => {
                      setSearchCatSegment6f(e.currentTarget.value);
                    }}
                    style={{ width: "100%" }}
                  />
                </Menu.Target>
                <Menu.Dropdown>
                  <ScrollArea
                    h={
                      dataCatSegment6f.length <= 1
                        ? 32
                        : dataCatSegment6f.length === 2
                          ? 64
                          : dataCatSegment6f.length === 3
                            ? 96
                            : dataCatSegment6f.length === 4
                              ? 128
                              : dataCatSegment6f.length === 5
                                ? 160
                                : dataCatSegment6f.length === 6
                                  ? 192
                                  : 225
                    }
                    offsetScrollbars
                    scrollbars="y"
                  >
                    {menuCatSegment6f}
                  </ScrollArea>
                </Menu.Dropdown>
              </Menu>
            </Box>
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              size="sm"
              placeholder="Mã hãng sản xuất"
              clearable
              searchable
              data={dataBrand}
              value={search.DsMaHangSx}
              renderOption={renderMultiSelectOptionBrand}
              leftSection={<IconTrademark size={20} color="#15aabf" />}
              onClick={() => {
                if (dataBrand.length === 0) {
                  getDataBrand();
                }
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "DsMaHangSx");
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <MultiSelect
              placeholder="Nhập mã NCC"
              type="text"
              data={dataVendor}
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              value={search.MaNCC}
              searchable
              clearable
              onClick={() => {
                if (dataVendor.length === 0) {
                  fetchDataVendorSelect();
                }
              }}
              onChange={(value) => {
                handleChangeSearchValue(value, "DsMaNCC");
              }}
              nothingFoundMessage="Không tìm thấy dữ liệu !"
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              type="number"
              placeholder="Tuổi tồn kho (Bắt đầu)"
              leftSection={<IconRulerMeasure size={"20"} color="#15aabf" />}
              defaultValue={FromTuoiTonKho}
              onChange={(e) => setFromTuoiTonKho(e.target.value)}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <TextInput
              placeholder="Tuổi tồn kho (Kết thúc)"
              leftSection={<IconRulerMeasure size={"20"} color="#15aabf" />}
              defaultValue={ToTuoiTonKho}
              onChange={(e) => setToTuoiTonKho(e.target.value)}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              color="blue"
              variant="outline"
              onClick={() => {
                fetchData();
              }}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </Box>
  );
};

export default SalesBarcodeV2;
